import { Flex, Heading, Image, Stack } from '@grubhubprod/gh-cookbook-react';
import { Copy } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export interface IIllustrationProps {
  mediaUrl: string;
  title: string;
  text: string;
  width?: string;
}

export function Illustration({
  mediaUrl,
  title,
  text,
  width = '80',
}: IIllustrationProps): JSX.Element {
  const { isPhone } = useScreenSizes();

  return (
    <Flex flexDirection="column" alignItems="center">
      <Stack y="md">
        <Image
          width={width}
          src={mediaUrl}
          alt="illustration"
          aria-label={title}
        />
      </Stack>

      <Stack y={isPhone ? 'md' : 'sm'}>
        <Heading variant="h4" textAlign="center">
          {title}
        </Heading>
      </Stack>

      <Copy variant="body" textAlign="center">
        {text}
      </Copy>
    </Flex>
  );
}
